import { findThumbnail } from '@marketplace-web/shared/utils'

import { ProductItemUserModel } from '../types/product-item-user'
import { UserThumbnailSize } from '../constants/item-thumbnails'

const transformUserPhotoDto = (photoDto: {
  url: string
  thumbnails: Array<{
    type: UserThumbnailSize
    url: string
  }>
}) => ({
  url: photoDto.url,
  thumbnails: photoDto.thumbnails,
})

export const transformPartialUserDtoToProductItemUser = (
  user: Partial<{
    id: number
    login: string
    photo: {
      url: string
      thumbnails: Array<{
        type: UserThumbnailSize
        url: string
      }>
    } | null
    profile_url: string
    business: boolean
  }>,
): ProductItemUserModel => ({
  id: user.id,
  login: user.login,
  photo: user.photo ? transformUserPhotoDto(user.photo) : null,
  thumbnailUrl: findThumbnail(user.photo),
  profileUrl: user.profile_url,
  isBusiness: user.business,
})
